// @ts-nocheck
export const localeCodes =  [
  "en",
  "es",
  "pt",
  "ja",
  "ko",
  "de",
  "it",
  "fr",
  "zh"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_getLocaleMessages_46ts_794b97bc",
      load: () => import("#nuxt-i18n/794b97bc" /* webpackChunkName: "locale_getLocaleMessages_46ts_794b97bc" */),
      cache: false
    }
  ],
  es: [
    {
      key: "locale_getLocaleMessages_46ts_794b97bc",
      load: () => import("#nuxt-i18n/794b97bc" /* webpackChunkName: "locale_getLocaleMessages_46ts_794b97bc" */),
      cache: false
    }
  ],
  pt: [
    {
      key: "locale_getLocaleMessages_46ts_794b97bc",
      load: () => import("#nuxt-i18n/794b97bc" /* webpackChunkName: "locale_getLocaleMessages_46ts_794b97bc" */),
      cache: false
    }
  ],
  ja: [
    {
      key: "locale_getLocaleMessages_46ts_794b97bc",
      load: () => import("#nuxt-i18n/794b97bc" /* webpackChunkName: "locale_getLocaleMessages_46ts_794b97bc" */),
      cache: false
    }
  ],
  ko: [
    {
      key: "locale_getLocaleMessages_46ts_794b97bc",
      load: () => import("#nuxt-i18n/794b97bc" /* webpackChunkName: "locale_getLocaleMessages_46ts_794b97bc" */),
      cache: false
    }
  ],
  de: [
    {
      key: "locale_getLocaleMessages_46ts_794b97bc",
      load: () => import("#nuxt-i18n/794b97bc" /* webpackChunkName: "locale_getLocaleMessages_46ts_794b97bc" */),
      cache: false
    }
  ],
  it: [
    {
      key: "locale_getLocaleMessages_46ts_794b97bc",
      load: () => import("#nuxt-i18n/794b97bc" /* webpackChunkName: "locale_getLocaleMessages_46ts_794b97bc" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_getLocaleMessages_46ts_794b97bc",
      load: () => import("#nuxt-i18n/794b97bc" /* webpackChunkName: "locale_getLocaleMessages_46ts_794b97bc" */),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_getLocaleMessages_46ts_794b97bc",
      load: () => import("#nuxt-i18n/794b97bc" /* webpackChunkName: "locale_getLocaleMessages_46ts_794b97bc" */),
      cache: false
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/85cf03a6" /* webpackChunkName: "config_vuei18n_46config_46ts_85cf03a6" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English"
  },
  {
    code: "es",
    language: "es-ES",
    name: "Español"
  },
  {
    code: "pt",
    language: "pt-BR",
    name: "Portugues"
  },
  {
    code: "ja",
    language: "ja-JP",
    name: "Japanese"
  },
  {
    code: "ko",
    language: "ko-KR",
    name: "Korean"
  },
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch"
  },
  {
    code: "it",
    language: "it-IT",
    name: "Italiano"
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Francais"
  },
  {
    code: "zh",
    language: "zh-CN",
    name: "Chinese"
  }
]
/** client **/

/** client-end **/